import React, { useState, useEffect, useContext } from "react";
import { getUsers, getScenarios } from "../../services/api";
import { ActivityContext } from "../activity";

import { Checkbox, Slider, Space } from "antd";
import GainButton from "../../components/objects/GainButton";
import GainSelect from "../../components/objects/GainSelect";
import GainIcon from "../../components/gainicon";

export default function Filter() {
  const { defaults, filterData, setFilterData, ActivityData } =
    useContext(ActivityContext);
  const [Filters, setFilters] = useState(filterData);
  const [Users, setUsers] = useState({
    options: [
      {
        id: 0,
        name: "All Owners",
        value: "All Owners",
      },
    ],
    value: 0,
  });
  const [Scenarios, setScenarios] = useState({
    options: [],
    value: [],
  });
  useEffect(() => {
    userLists();
  }, []);

  useEffect(() => {
    scenarioLists();
    // Lists();
  }, []);

  const userLists = async () => {
    const res = await getUsers();
    const data = res.data.data.map((option) => ({
      id: option.id,
      name: option.firstname,
      value: option.file_name,
    }));
    setUsers({ ...Users, options: [...Users.options, ...data] });
  };

  useEffect(() => {
    scenarioLists();
  }, [Users]);

  const scenarioLists = async () => {
    const res = await getScenarios();
    console.log(res);
    const options = res.data
      .map((option) => ({
        id: option.id,
        name: option.scenario_name,
        value: option.file_name,
        owner: option.owner.id,
      }))
      .filter((option) =>
        Users.value ? Users.value === option.owner : option
      );
    Lists(options);
  };

  const Lists = async (options) => {
    // const options = await scenarioLists();
    if (options.length > 0) {
      setScenarios({
        ...Scenarios,
        options: [...options],
        value: options[0]?.id,
      });
      setFilters({
        ...Filters,
        scenarios: [{ name: options[0].name, file: options[0].value }],
      });

      ActivityData([{ name: options[0].name, file: options[0].value }]);

      setFilterData({
        ...Filters,
        scenarios: [{ name: options[0].name, file: options[0].value }],
      });
    } else {
      setScenarios({
        ...Scenarios,
        options: [],
        value: [],
      });
      setFilters({
        ...Filters,
        scenarios: [],
      });
      ActivityData([]);
      setFilterData({
        ...Filters,
        scenarios: [],
      });
    }
  };

  const Show = () => {
    setFilterData(Filters);
  };
  return (
    <Space direction="vertical" size="large">
      <div
        className="cursor-pointer float-right"
        onClick={() => {
          console.log(defaults);
          setFilters(defaults);
          userLists();
        }}
      >
        <GainIcon name="refresh" />
      </div>
      <div>
        <GainSelect
          label={<span className="font-bold">Road transport</span>}
          options={[
            {
              name: "Fuel consumption",
              value: "1. FC",
            },
            {
              name: "Control Technology",
              value: "2. CT",
            },
          ]}
          default={Filters.sheet}
          onChange={(value) => setFilters({ ...Filters, sheet: value })}
          nospace
        />
      </div>
      <div>
        <h1 className="font-bold text-base">Sector</h1>
        <Checkbox.Group
          style={{ width: "100%" }}
          onChange={(val) => setFilters({ ...Filters, sectors: val })}
          value={Filters.sectors}
        >
          <div className="grid grid-cols-1">
            <Checkbox value="TRA_RD_HDB">TRA_RD_HDB</Checkbox>
            <Checkbox value="TRA_RD_HDT">TRA_RD_HDT</Checkbox>
            <Checkbox value="TRA_RD_LD4C">TRA_RD_LD4C</Checkbox>
            <Checkbox value="TRA_RD_LD4T">TRA_RD_LD4T</Checkbox>
            <Checkbox value="TRA_RD_M4">TRA_RD_M4</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
      <div>
        <div className="font-bold text-base">Emission Scenario</div>
        <GainSelect
          options={Users.options}
          nospace
          default={Users?.options[0]?.id}
          onChange={(val) => setUsers({ ...Users, value: val })}
          useId
        />
        <GainSelect
          options={Scenarios.options}
          nospace
          multiple
          useId
          onChange={(val) => {
            const scenarios = Scenarios.options
              .filter((item) => val.includes(item.id))
              .map((item) => ({ name: item.name, file: item.value }));
            setFilters({ ...Filters, scenarios });
            setScenarios({ ...Scenarios, value: val });
          }}
          value={Scenarios.value}
        />
      </div>
      <div>
        <div className="font-bold text-base">Region</div>
        <GainSelect nospace disabled />
        <GainSelect disabled nospace />
      </div>
      <div>
        <h1 className="font-bold text-base">
          Year{" "}
          <span className="font-normal text-sm">{`( ${Filters.rangestart} - ${Filters.rangeend} )`}</span>
        </h1>
        <Slider
          range
          tipFormatter={(val) => val + 2010}
          max={40}
          value={[Filters.rangestart - 2010, Filters.rangeend - 2010]}
          onChange={(val) =>
            setFilters({
              ...Filters,
              rangestart: val[0] + 2010,
              rangeend: val[1] + 2010,
            })
          }
        />
      </div>
      <div>
        <h1 className="font-bold text-base">Activity</h1>
        <Checkbox.Group
          style={{ width: "100%" }}
          name="activity"
          onChange={(val) => setFilters({ ...Filters, activities: val })}
          value={Filters.activities}
        >
          <div className="grid grid-cols-2">
            <Checkbox value="GAS">GAS</Checkbox>
            <Checkbox value="GAL">GAL</Checkbox>
            <Checkbox value="LPG">LPG</Checkbox>
            <Checkbox value="MD">MD</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
      <div className="w-full pb-4 pt-12" onClick={Show}>
        <GainButton label="Show" center />
      </div>
    </Space>
  );
}
